import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { RadioButtonGroup, RadioButton } from 'material-ui/RadioButton';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import { Trans, withTranslation } from 'react-i18next';

import Container from 'app/components/container';
import TextEditor from 'app/components/textEditor';
import Toggle from 'app/components/toggle';
import Range from 'app/components/range';
import Subtitle from 'app/components/subtitle';

import { Tabs, Tab } from 'modules/editor/components/tabs';
import SectionHeader from 'modules/editor/components/sectionHeader';
import ButtonDesignMenu from 'modules/editor/components/buttonDesignMenu';
import ButtonLinkMenu from 'modules/editor/components/buttonLinkMenu';
import ImageDesignMenu from 'modules/editor/components/imageDesignMenu';
import ColorPicker from 'modules/editor/components/colorPicker';
import DesignToggle from 'modules/editor/components/designToggle';
import ImageUpload from 'modules/editor/internals/imageUpload';

import LayoutTab from '../../tabs/layoutTab';
import LayoutOption from '../../tabs/layoutTab/layoutOption';
import headerSmall from './headerSmall';
import headerMedium from './headerMedium';
import headerLarge from './headerLarge';
import headerFullScreen from './headerFullScreen';
import FullScreen from './desktop/fullscreen';
import TwoThird from './desktop/twoThird';
import Half from './desktop/half';
import ColumnImageLeft from './desktop/columnImageLeft';
import ColumnImageRight from './desktop/columnImageRight';
import TwoThirdImageLeft from './desktop/twoThirdImageLeft';
import TwoThirdImageRight from './desktop/twoThirdImageRight';
import OneThirdCenter from './desktop/oneThirdCenter';
import TwoThirdCenter from './desktop/twoThirdCenter';
import themeStyles from '../../../../../../../_export.scss';

class Header extends Component {
  static propTypes = {
    appname: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired,
    design: PropTypes.object.isRequired,
    component: PropTypes.object.isRequired,
    pages: PropTypes.array.isRequired,
    match: PropTypes.object.isRequired,
    googleAnalytics: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    onDesignChange: PropTypes.func.isRequired,
    onLoadGoogleAnalytics: PropTypes.func.isRequired,
    onButtonDesignChange: PropTypes.func.isRequired,
    addNewButton: PropTypes.func.isRequired,
    deleteButton: PropTypes.func.isRequired,
    onChangeNewButton: PropTypes.func.isRequired,
    onExtraButtonDesignChange: PropTypes.func.isRequired,
  };

  async componentDidMount() {
    this.props.onLoadGoogleAnalytics();
  }

  getDimensions = index =>
    this.dimensions.medium && this.dimensions.medium[index];
  s;

  handleChange = prop => value => this.props.onChange(prop, value);
  handleAddNewButton = () => this.props.addNewButton();
  handleDeleteButton = key => this.props.deleteButton(key);
  handleDesign = prop => (e, value) => this.props.onDesignChange(prop, value);
  handleExtraButtonDesign = (prop, key) => (e, value) =>
    this.props.onExtraButtonDesignChange(prop, value, key);
  handleChangeLinkSection = (prop, value) => this.props.onChange(prop, value);
  handleChangeNewBtnLinkSection = (prop, value, key) => {
    this.props.onChangeNewButton(prop, value, key);
  };

  handleToggle = prop => (e, isToggled) => this.props.onChange(prop, isToggled);

  handleColorChange = prop => value => {
    const rgba = `rgba(${value.rgb.r},${value.rgb.g},${value.rgb.b},${value.rgb.a})`;
    this.props.onDesignChange(prop, rgba);
  };

  headerLayoutsOptions = () => {
    const { t } = this.props;
    const style = {
      width: '100%',
      heigth: '100%',
    };
    return {
      options: [
        <LayoutOption
          key="header_layout"
          wrapperKey="header_layout"
          grid={2}
          tooltip={t('Change your mobile header component template')}
          title={t('Mobile Header templates')}
          active={this.props.component.layout}
          items={[
            {
              value: 'FullScreen',
              icon: headerFullScreen,
              style,
              size: '430px by 873px',
            },
            {
              value: 'Large',
              icon: headerLarge,
              style,
              size: '430px by 699px',
            },
            {
              value: 'Medium',
              icon: headerMedium,
              style,
              size: '430px by 466px',
            },
            {
              value: 'Small',
              icon: headerSmall,
              style,
              size: '430px by 279px',
            },
          ]}
        />,
        <LayoutOption
          type="desktop"
          key="header_layout"
          wrapperKey="header_layout"
          grid={1}
          tooltip={t('Change your desktop header component template')}
          title={t('Desktop Header templates')}
          active={this.props.component.desktopLayout}
          items={[
            {
              value: 'Desktop_FullScreen',
              icon: FullScreen,
              style,
              size: '1630px by 730px',
            },
            {
              value: 'Desktop_TwoThird',
              icon: TwoThird,
              style,
              size: '1630px by 635px',
            },
            {
              value: 'Desktop_Half',
              icon: Half,
              style,
              size: ' 1630px by  423px',
            },
            {
              value: 'Desktop_ColumnImageLeft',
              icon: ColumnImageLeft,
              style,
              size: '827px by 730px',
            },
            {
              value: 'Desktop_ColumnImageRight',
              icon: ColumnImageRight,
              style,
              size: '827px by 730px',
            },
            {
              value: 'Desktop_TwoThirdImageLeft',
              icon: TwoThirdImageLeft,
              style,
              size: '992px by 730px',
            },
            {
              value: 'Desktop_TwoThirdImageRight',
              icon: TwoThirdImageRight,
              style,
              size: '992px by 730px',
            },
            {
              value: 'Desktop_OneThirdCenter',
              icon: OneThirdCenter,
              style,
              size: '1630px by 730px',
            },
            {
              value: 'Desktop_TwoThirdCenter',
              icon: TwoThirdCenter,
              style,
              size: '1630px by 730px',
            },
          ]}
        />,
      ],
    };
  };

  render() {
    const borderStyles = [
      'Solid',
      'Double',
      'Dotted',
      'Dashed',
      'Ridge',
      'Groove',
      'Inset',
      'Outset',
    ];

    const {
      appname,
      data,
      component,
      design,
      pages,
      match,
      onDesignChange,
      onButtonDesignChange,
      onExtraButtonDesignChange,
      t,
    } = this.props;

    const buttonToggle = (
      <Toggle
        onToggle={this.handleDesign('/buttonDesign/enabled')}
        toggled={component.design.buttonDesign.enabled}
        disabled={!component.design.enabled}
      />
    );
    const toolbarButtons = {
      fonts: true,
      fontSize: true,
      bold: true,
      italic: true,
      underline: true,
      url: true,
      image: true,
      video: true,
      orderedList: true,
      unorderedList: true,
      negativeIntent: true,
      positiveIndent: true,
      textAlign: true,
      textColor: true,
      textBackground: true,
      clearTextFormatting: true,
      codeBlock: true,
      blockquote: true,
    };

    return (
      <Tabs>
        <Tab label={t('content')}>
          <Container>
            <SectionHeader
              title={t('Mobile Image / Video Upload')}
              tooltip={t('This image/video will show up for mobile users')}
            />
            <ImageUpload
              targetId="header_component_upload"
              title={t('Media Upload')}
              src={data.image}
              firebaseUrl={`/apps/${match.params.appname}/draft/lazy_data/${component.lazy_data}/image`}
              showCropAreaSizes
              height="220px"
              width="320px"
              isVideoAllowed
            />
            <SectionHeader
              title={t('Desktop Image / Video Upload')}
              tooltip={t('This image/video will show up for desktop users')}
            />
            <ImageUpload
              targetId="desktop_header_component_upload"
              title={t('Desktop Media Upload')}
              src={data.desktopImage}
              firebaseUrl={`/apps/${match.params.appname}/draft/lazy_data/${component.lazy_data}/desktopImage`}
              showCropAreaSizes
              height="220px"
              width="320px"
              isVideoAllowed
            />
            <SectionHeader
              title={t('Mobile Title')}
              tooltip={t('A caption for background image for mobile users')}
              borderTop
            />
            <TextEditor
              id="title"
              value={data.title}
              onChange={this.handleChange('title')}
              placeholder={t('Mobile Title')}
              toolbar={toolbarButtons}
            />
            <SectionHeader
              title={t('Mobile Subtitle')}
              tooltip={t('A caption for background image for mobile users')}
              borderTop
            />
            <TextEditor
              id="subtitle"
              value={data.subtitle}
              onChange={this.handleChange('subtitle')}
              placeholder={t('Mobile Subtitle')}
              toolbar={toolbarButtons}
            />

            <div style={{ margin: '50px 0px' }}>
              <div style={{ marginBottom: '20px' }}>
                <SectionHeader
                  title={t('Enable Desktop Title & Subtitle')}
                  enabled={data.desktopEnabled || false}
                  actions={
                    <Toggle
                      toggled={data.desktopEnabled}
                      onToggle={this.handleToggle('desktopEnabled')}
                      trackSwitchedStyle={{
                        backgroundColor: themeStyles.primaryColorLight,
                      }}
                      thumbSwitchedStyle={{
                        backgroundColor: themeStyles.primaryColor,
                      }}
                    />
                  }
                  tooltip={t('Add title & subtitle for desktop users')}
                  borderTop
                  borderBottom
                />
              </div>
              {data.desktopEnabled && (
                <React.Fragment>
                  <SectionHeader
                    title={t('Desktop Title')}
                    tooltip={t(
                      'A caption for background image for desktop users',
                    )}
                    borderTop
                    enabled={data.desktopEnabled || false}
                  />
                  <TextEditor
                    id="desktopTitle"
                    value={
                      data.desktopTitle ||
                      `<p>${t(
                        "Click on the editor pane on the left to start typing the 'Title' you want to",
                      )} <strong>${t('display')}</strong>! ${t(
                        'and ensure you click on',
                      )} <strong>'Save'</strong> ${t('once done!')}</p>`
                    }
                    onChange={this.handleChange('desktopTitle')}
                    placeholder={t('Desktop Title')}
                    toolbar={toolbarButtons}
                    disabled={!data.desktopEnabled}
                  />
                  <SectionHeader
                    title={t('Desktop Subtitle')}
                    tooltip={t(
                      'A caption for background image for desktop users',
                    )}
                    borderTop
                    enabled={data.desktopEnabled || false}
                  />
                  <TextEditor
                    id="desktopSubtitle"
                    value={
                      data.desktopSubtitle ||
                      `<p>${t(
                        "Click on the editor pane on the left to start typing the 'Subtitle' you want to",
                      )} <strong>${t('display')}</strong>! ${t(
                        'and ensure you click on',
                      )} <strong>'${t('Save')}'</strong> ${t('once done!')}</p>`
                    }
                    onChange={this.handleChange('desktopSubtitle')}
                    placeholder={t('Desktop Subtitle')}
                    toolbar={toolbarButtons}
                    disabled={!data.desktopEnabled}
                  />
                </React.Fragment>
              )}
            </div>
            <ButtonLinkMenu
              link={data.link}
              pages={pages}
              buttonOptional
              borderTop
              onChange={this.handleChangeLinkSection}
              lazyData={component.lazy_data}
              googleAnalytics={this.props.googleAnalytics}
              gaEnabled={this.props.data.gaEnabled}
              gaCategory={this.props.data.gaCategory}
              gaAction={this.props.data.gaAction}
              index={1}
            />

            <div style={{ marginTop: '20px', width: '100%' }}>
              <React.Fragment>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    padding: '10px',
                  }}
                >
                  {(!data.extraButtons ||
                    (data.extraButtons &&
                      Object.keys(data.extraButtons).length < 5)) && (
                    <Button
                      style={{
                        fontSize: '14px',
                        textTransform: 'capitalize',
                        fontWeight: 'bold',
                        color: '#261ed5',
                      }}
                      onClick={this.handleAddNewButton}
                    >
                      + <Trans>Add a new button</Trans>
                    </Button>
                  )}
                </div>

                <div>
                  {data.extraButtons &&
                    Object.keys(data.extraButtons).length > 0 &&
                    Object.keys(data.extraButtons).map((key, index) => (
                      <div key={key} style={{ marginBottom: '20px' }}>
                        <ButtonLinkMenu
                          link={data.extraButtons[key].link}
                          pages={pages}
                          buttonOptional
                          borderTop
                          onChange={(prop, value) =>
                            this.handleChangeNewBtnLinkSection(prop, value, key)
                          }
                          lazyData={component.lazy_data}
                          googleAnalytics={this.props.googleAnalytics}
                          gaEnabled={data.extraButtons[key].gaEnabled}
                          gaCategory={data.extraButtons[key].gaCategory}
                          gaAction={data.extraButtons[key].gaAction}
                          index={index + 2}
                        />
                        <div
                          style={{
                            marginTop: '10px',
                            display: 'flex',
                            justifyContent: 'flex-end',
                            padding: '0px 10px',
                          }}
                        >
                          <Button
                            variant="contained"
                            size="small"
                            style={{
                              fontSize: '14px',
                              textTransform: 'capitalize',
                              fontWeight: 'bold',
                              color: 'red',
                              backgroundColor: 'transparent',
                              borderRadius: '5px',
                              border: '1px solid red',
                              boxShadow: 'none',
                            }}
                            onClick={() => this.handleDeleteButton(key)}
                          >
                            <Trans>{`Remove Button ${index + 2}`}</Trans>
                          </Button>
                        </div>
                      </div>
                    ))}
                </div>
              </React.Fragment>
              )}
            </div>
          </Container>
        </Tab>
        <Tab label={t('design')}>
          <Container style={{ marginBottom: '40px' }}>
            <DesignToggle
              component={component}
              onDesignChange={onDesignChange}
            />
            <ColorPicker
              label={t('Text Color')}
              color={component.design.textColor}
              height={22}
              disabled={!component.design.enabled}
              onChange={this.handleColorChange('textColor')}
            />
            <ColorPicker
              label={t('Background Color')}
              color={design.backgroundColor}
              height={22}
              disabled={!component.design.enabled}
              onChange={this.handleColorChange('backgroundColor')}
            />
            <ColorPicker
              label={t('Border Color')}
              color={design.borderColor}
              height={22}
              disabled={!component.design.enabled}
              onChange={this.handleColorChange('borderColor')}
            />
            <Subtitle className={!component.design.enabled}>
              <Trans>Border Width</Trans>
            </Subtitle>
            <Range
              min={0}
              max={100}
              step={1}
              label={
                !design.borderWidth || design.borderWidth === 0
                  ? '0px'
                  : `${design.borderWidth}px`
              }
              value={design.borderWidth}
              onChange={(el, val) => onDesignChange('borderWidth', val)}
              disabled={!component.design.enabled}
              width="320px"
            />
            <Subtitle className={!component.design.enabled}>
              <Trans>Border Style</Trans>
            </Subtitle>
            <RadioButtonGroup
              className="radio-button-group"
              label={t('Border Style')}
              style={{
                padding: '0 10px',
                margin: '0 auto',
                flexDirection: 'column',
              }}
              name="background-type"
              onChange={(el, val) => onDesignChange('borderStyle', val)}
              valueSelected={design.borderStyle}
            >
              {borderStyles.map(style => (
                <RadioButton
                  key={style}
                  value={style.toLowerCase()}
                  label={style}
                  style={{
                    fontSize: 12,
                    lineHeight: 22,
                  }}
                  disabled={!component.design.enabled}
                />
              ))}
            </RadioButtonGroup>
            <ImageDesignMenu
              component={component}
              onDesignChange={onDesignChange}
            />
            <SectionHeader
              title={`${t('Button')} ${1}`}
              actions={buttonToggle}
              tooltip={t(`${'Define the styles for button' + ' '}${1}`)}
              borderTop
            />
            <ButtonDesignMenu
              component={component}
              onDesignChange={onButtonDesignChange}
            />

            {data.extraButtons &&
              Object.keys(data.extraButtons).length > 0 &&
              Object.keys(data.extraButtons).map((key, index) => (
                <div key={key} style={{ marginTop: '20px', width: '100%' }}>
                  <SectionHeader
                    title={`${t('Button')} ${index + 2}`}
                    enabled={data.extraButtons[key].design.buttonDesign.enabled}
                    actions={
                      <Toggle
                        onToggle={this.handleExtraButtonDesign('enabled', key)}
                        toggled={
                          data.extraButtons[key].design.buttonDesign.enabled
                        }
                        disabled={!component.design.enabled}
                      />
                    }
                    tooltip={t(
                      `${'Define the styles for button' + ' '}${index + 2}`,
                    )}
                    borderTop
                  />
                  <ButtonDesignMenu
                    component={{
                      type: 'Header',
                      lazy_data: component.lazy_data,
                      design: data.extraButtons[key].design,
                    }}
                    onDesignChange={(type, value) =>
                      onExtraButtonDesignChange(type, value, key)
                    }
                  />
                </div>
              ))}

            <div style={{ marginTop: '40px', width: '100%' }}>
              <Subtitle className={!component.design.enabled}>
                <Trans>Desktop Button Text Size</Trans>
              </Subtitle>
              <Range
                min={0}
                max={25}
                step={1}
                label={
                  !design.desktopButtonTextSize ||
                  design.desktopButtonTextSize === 0
                    ? '15px'
                    : `${design.desktopButtonTextSize}px`
                }
                value={design.desktopButtonTextSize || 15}
                onChange={(el, val) =>
                  onDesignChange('desktopButtonTextSize', val)
                }
                disabled={!component.design.enabled}
                width="320px"
              />

              <Subtitle className={!component.design.enabled}>
                <Trans>Mobile Button Text Size</Trans>
              </Subtitle>
              <Range
                min={0}
                max={25}
                step={1}
                label={
                  !design.mobileButtonTextSize ||
                  design.mobileButtonTextSize === 0
                    ? data.horizontalViewEnabled
                      ? '12px'
                      : '15px'
                    : `${design.mobileButtonTextSize}px`
                }
                value={
                  design.mobileButtonTextSize ||
                  (data.horizontalViewEnabled ? 12 : 15)
                }
                onChange={(el, val) =>
                  onDesignChange('mobileButtonTextSize', val)
                }
                disabled={!component.design.enabled}
                width="320px"
              />
              <SectionHeader
                title={t('Button Horizontal View')}
                enabled={data.horizontalViewEnabled || false}
                actions={
                  <Toggle
                    toggled={data.horizontalViewEnabled}
                    onToggle={this.handleToggle('horizontalViewEnabled')}
                    trackSwitchedStyle={{
                      backgroundColor: themeStyles.primaryColorLight,
                    }}
                    thumbSwitchedStyle={{
                      backgroundColor: themeStyles.primaryColor,
                    }}
                  />
                }
                tooltip={t('Horizontal view for buttons')}
                borderTop
                borderBottom
              />
            </div>
          </Container>
        </Tab>
        <Tab label={t('layout')}>
          <LayoutTab
            componentKey={component.key}
            appname={appname}
            {...this.headerLayoutsOptions()}
          />
        </Tab>
      </Tabs>
    );
  }
}

export default withTranslation()(Header);
